import {
    getMakersShort,
    getActorLifetime,
    stringifyDimension
} from '@/helpers';


/**
 * EntityMixin - "lightweight" methods to deal with various "entities" (=resources)
 */
export default {

    data: function () {
        return {
            resource: '' // artworks, collections, actors, ...
        };
    },

    methods: {

        getName: function () {
            return this.item && (this.item.Name || this.item.ActorName || this.item.ActorSortName);
        },

        getOwnerName: function () {
            return this.item && this.item.Owner;
        },

        getTitle: function () {
            return this.getName() || ' ';
        },

        /**
        * Return Artwork title in the long form of
        * <MakersShort or Makers joined> – <Name, Caption or "unknown">, <ProductionTimeSpanName>
        */
        getArtworkTitle: function (item, hideUnknown) {
            if (!item) {
                return '';
            }
            let title = '';
            // MakersShort or Makers stringified
            const makers = getMakersShort(item);
            if (makers) {
                title += `${makers} – `;
            }
            // Name or Caption
            if (item.Name || item.Caption) {
                title += (item.Name || item.Caption);
            }
            else if (!hideUnknown) {
                // add unknown to title
                title += this.$t('common.unknown_lc');
            }
            // ProductionTimeSpanName
            if (item.ProductionTimeSpanName) {
                title += `, ${item.ProductionTimeSpanName}`;
            }
            return title;
        },

        getIngressText: function (item) {
            return (item && item.IngressText) || '';
        },

        getAudios: function (item) {
            return (item && item.AudioPlaylist) || [];
        },

        getVideos: function (item) {
            return (item && item.VideoPlaylist) || [];
        },

        getVideoCaption: function (item) {
            if (item && item.Caption) {
                return item.Caption;
            }
            else if (item && item.VideoPlayer && item.VideoPlayer.Caption) {
                return item.VideoPlayer.Caption;
            }
        },

        getContact: function () {
            const { item } = this;
            if (!item) {
                return "";
            }
            let contact = "";
            if (item.LocalityArea) {
                contact += item.LocalityArea;
            }
            return contact;
        },

        getCuratorName: function (item) {
            return item && item.Curator && item.Curator.Name;
        },

        /**
        * Return Actor Type as localized string
        */
        localizeActorType: function (actorType) {
            if (actorType === "taiteilija") {
                return this.$t(`actors.actorType.${actorType}`);
            }
            return actorType;
        },

        /**
        * Return Actor Type as localized string
        */
        getActorType: function (actor) {
            return this.localizeActorType(actor && actor.ActorType);
        },

        getActorLifetime,

        getMakersShort,

        /**
        * Return Maker Role as localized string
        */
        getMakerRole: function (maker) {
            return this.localizeActorType(maker && maker.Role);
        },

        /**
         * Result item dimensions.
         * @param {Object} - result item
         * @returns {String}
         */
        getDimensions: function (item) {
            let dimensions = '';

            if (item && item.DimensionsShort) {
                dimensions = item.DimensionsShort.replace('x', '×');
            }
            else if (item && item.Dimensions && item.Dimensions.length) {
                if (item.Dimensions.length === 1) {
                    // only one dimension (diameter)
                    const d = item.Dimensions[0];
                    return stringifyDimension(d);
                }

                // format the first two dimensions
                const [y, x] = item.Dimensions.slice(0, 2);
                const yUnit = (x.Unit === y.Unit ? '' : y.Unit + ' ');
                dimensions = `${y.Value} ${yUnit}× ${x.Value} ${x.Unit}`;
            }

            // switch to commas for Finnish
            if (this.$store.getters['ux/getLocale'] === 'fi') {
                dimensions = dimensions.replace(/\./g, ',');
            }

            return dimensions;
        },

        /**
         * Ticket price currency.
         */
        getCurrency: function (ticketPrice) {
            return (ticketPrice && ticketPrice.PriceCurrency &&
                ticketPrice.PriceCurrency.replace('eur', '€')) || '';
        }
    }
};
